module.exports = __webpack_public_path__ + "static/media/loading.cac6f4f6.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/loading.gif
// module id = 279
// module chunks = 0